export default "__VITE_ASSET___3XgeTac__"